module.exports = __webpack_public_path__ + "media/images/element/01-97b66ff4bca150f83dccf67e61c04b33.png";